export default __webpack_public_path__ + "static/media/remoteLearn.png.webp";